// urlにprodが含まれる場合はprod-sanyo.myshopify.com、それ以外はstg-sanyo.myshopify.com
const shopDomain = document.querySelector('#shopDomain');
const SHOPIFY_STOREFRONT_API_URL = `https://${shopDomain.value}/api/graphql.json`;
const STOREFRONT_API_TOKEN = document.querySelector('#storeFrontAccessToken').value;

// Swiperを設定
function initializeSwipers() {
  const swiperElements = document.querySelectorAll('.wearing-item-swiper');
  console.log('swiperElements', swiperElements);
  swiperElements.forEach((_, i) => {
    const swiperContainer = document.querySelector(`.wearing-item-slider--${i}`);
    new Swiper(swiperContainer, {
      slidesPerView: 2.2,
      spaceBetween: 4,
      setWrapperSize: true,
      autoheight: true,
      initialSlide: 0,
      effect: 'slide',
      disabledClass: '.swiper-navigation-disabled',
      breakpoints: {
        500: {
          slidesPerView: 'auto',
        },
      },
      navigation: {
        nextEl: `.next--${i}`,
        prevEl: `.prev--${i}`,
      },
    });
  });
}

const categoryCode = {
  '010': 'アウター',
  '020': 'ジャケット',
  '030': 'スーツ',
  '040': 'ベスト',
  '050': 'トップス',
  '060': 'ワンピース',
  '070': 'オーバーオール',
  '080': 'パンツ',
  '090': 'スカート',
  100: 'バッグ',
  110: 'ベルト',
  120: 'シューズ',
  130: '雑貨',
  140: 'グローブ',
  150: '傘',
  160: 'その他',
};

window.addEventListener('DOMContentLoaded', async () => {
  // 関連商品を取得
  try {
    const wearingItemsContainer = document.querySelectorAll('#wearingItemsContainer');
    const wearingItems = await getWearingItems();
    if (!wearingItems) return;
    // 着用アイテムを表示順にソート
    wearingItems.sort((a, b) => a.order - b.order);
    wearingItemsContainer.forEach((element, i) => {
      element.innerHTML = wearingItemsTemplateCreator(wearingItems, i);
    });

    initializeSwipers();
  } catch (error) {
    console.error(error);
  }
});

const wearingItemsTemplateCreator = (wearingItems, parentIndex) => {
  return wearingItems
    .map((item, i, self) => {
      if (item.variants.length === 0) return '';
      const index = self.length * parentIndex + i;
      const variants = item.variants
        .map(variant => {
          return `
					<li class="swiper-slide">
						<a class="productDetail__info__recommend__link" href="${variant.productUrl}">
							<img
								src="${variant.image.originalSrc}"
								alt=""
								class="productDetail__product__item__style__img"
							>
							<p class="productDetail__product__item__style__name">${
                categoryCode[variant.product.metafield.value]
              }</p>
						</a>
					</li>
				`;
        })
        .join('');
      return `
			<li class="productDetail__product__item__styleBook__container">
				<div class="productDetail__product__item__mainStyle">
					<img
						src="${item.productImage}"
						alt=""
						class="productDetail__product__item__style__main__img"
					>
				</div>
				<div class="wearing-item-swiper swiper product__item__slider wearing-item-slider--${index}">
					<ul class="swiper-wrapper">
						${variants}
					</ul>
				</div>
				<div class="wearing-item-prev prev--${index}"></div>
				<div class="wearing-item-next next--${index} ${
        item.variants.length > 3 ? '' : 'swiper-button-disabled'
      }"></div>
			</li>
		`;
    })
    .join('');
};

// 商品ID配列を受け取り、ShopifyのStoreFrontAPIから商品詳細を取得し、商品配列にして返す
const getWearingItems = async () => {
  if (!document.getElementById('wearingItems')) return;
  const wearingProducts = JSON.parse(document.getElementById('wearingItems').innerText || '[]');
  const productId = document.getElementById('wearingItems').dataset.productId || '';
  const wearingItems = [];

  for await (const product of wearingProducts) {
    const productData = await fetch(`${SHOPIFY_STOREFRONT_API_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': document.querySelector('#storeFrontAccessToken').value,
      },
      body: JSON.stringify({
        query: `{
          node(id: "gid://shopify/Product/${productId}") {
            ... on Product {
              id
              images(first: 100) {
                edges {
                  node {
                    id
                    originalSrc
                  }
                }
              }
            }
          }
        }`,
      }),
    })
      .then(res =>
        //エラーハンドリング
        {
          if (!res.ok) {
            throw new Error();
          }
          return res.json();
        }
      )
      .then(res => {
        return res.data.node;
      });

    // Filter images with matching id
    productData.images.edges = productData.images.edges.filter(
      edge => edge.node.id === product.imageGId
    );

    const variantItems = [];

    for await (const variant of product.variants) {
      const variantData = await fetch(`${SHOPIFY_STOREFRONT_API_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token':
            document.querySelector('#storeFrontAccessToken').value,
        },
        body: JSON.stringify({
          query: `{
            node(id: "${variant.variantId}") {
              ... on ProductVariant {
                id
                image {
                  originalSrc
                }
                product {
                  handle
                  metafield(namespace: "category", key: "code") {
                    value
                  }
                }
              }
            }
          }`,
        }),
      })
        .then(res =>
          //エラーハンドリング
          {
            if (!res.ok) {
              throw new Error();
            }
            return res.json();
          }
        )
        .then(res => {
          return res.data.node;
        });

      // Variantの商品のURLを生成
      if (variantData === null) continue;
      variantData.productUrl = `/products/${
        variantData.product.handle
      }?variant=${variantData.id.replace('gid://shopify/ProductVariant/', '')}`;

      variantItems.push(variantData);
    }

    wearingItems.push({
      order: product.order,
      productImage: productData.images.edges[0]?.node.originalSrc ?? '',
      variants: variantItems,
    });
  }
  console.log('wearingItems',wearingItems);
  return wearingItems;
};
